import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInterfaceArrows = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3710_53987)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6925 4.23047L2.07694 4.23047C1.48216 4.23047 1 4.71263 1 5.30741L0.999999 13.923C0.999999 14.5177 1.48216 14.9999 2.07694 14.9999L10.6925 14.9999C11.2873 14.9999 11.7694 14.5177 11.7694 13.923L11.7694 5.30741C11.7694 4.71263 11.2873 4.23047 10.6925 4.23047Z",
				stroke: "#006ADC",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.23056 0.999597L13.9231 0.999598C14.2087 0.999598 14.4826 1.11306 14.6846 1.31503C14.8865 1.51699 15 1.79092 15 2.07654L15 11.769",
				stroke: "#006ADC",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.30628 7.46155L8.53711 7.46155L8.53711 10.6924",
				stroke: "#006ADC",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.53711 7.46126L4.22933 11.769",
				stroke: "#006ADC",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3710_53987",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgInterfaceArrows);
export default ForwardRef;
